import { render, staticRenderFns } from "./OccurrenceStatus.vue?vue&type=template&id=3b6e3446"
import script from "./OccurrenceStatus.vue?vue&type=script&lang=js"
export * from "./OccurrenceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports